import React from 'react';
import { useSearchUserContext } from './SearchUserContext';
import { UserTableRow } from './UserTableRow';

const UserTable: React.FC = () => {
  const { foundUsers } = useSearchUserContext();
  return (
    <table className='users__table'>
      <thead>
        <tr key='head' className='users__table-header f4'>
          <th />
          <th>Email</th>
          <th>Allocated Licenses</th>
          <th>Status</th>
          <th />
        </tr>
      </thead>
      <tbody>
        {foundUsers.map((user) => (
          <UserTableRow key={user.id} user={user} />
        ))}
      </tbody>
    </table>
  );
};

export default UserTable;
